<template>
    <div class="horse-preview-studbook flex flex-column mt-2">
        <StudbookEntryStatus :horse="selectedHorse"/>
        <div class="flex w-full mt-4 gap-5">
            <div v-if="selectedHorse.imported" class="studbook studbook-original">
                <div class="header">{{ $t('message.horsePreview.studbook.original') }}</div>
                <div class="name">{{selectedHorse.previousBookTypeName}}</div>
                <div>{{ $t('message.horsePreview.studbook.referenceNumber') }}: {{selectedHorse.previousStudbookRegistryId}}</div>
                <div>
                    {{ $t('message.horsePreview.studbook.volume') }} {{selectedHorse.previousBookNumber }}
                    {{ getSupplementText(selectedHorse.previousBookAppendixNumber)}},
                    {{ $t('message.horsePreview.studbook.page') }} {{selectedHorse.previousBookPage}}
                </div>
            </div>
            <div class="studbook">
                <div class="header">{{ $t('message.horsePreview.studbook.current') }}</div>
                <div class="name">{{selectedHorse.bookTypeName}}</div>
                <div>{{ $t('message.horsePreview.studbook.referenceNumber') }}: {{selectedHorse.studbookRegistryId}}</div>
                <div>
                    {{ $t('message.horsePreview.studbook.volume') }} {{selectedHorse.bookNumber}}
                    {{ getSupplementText(selectedHorse.bookAppendixNumber)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import StudbookEntryStatus from "@/views/horse/horseEdit/main/components/StudbookEntryStatus.vue";

export default {
    name: "HorsePreviewStudbooks",
    components: {
        StudbookEntryStatus,
        CustomTextButton
    },

    props: {
        selectedHorse: {
            type: Object,
            required: true,
        },
    },

    methods: {
        getSupplementText(bookAppendixNumber) {
            if (bookAppendixNumber == null) return "";
            else return ", " + this.$t('message.horsePreview.studbook.supplement') + " " + bookAppendixNumber;
        },
    }
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.horse-preview-studbook {
    .studbook {
        display: flex;
        flex-direction: column;
        width: 50%;
        gap: 1rem;
        align-items: start;
        background: var(--primary-color);
        font-family: var(--decor-font-family);
        padding: 0.8rem 1rem;
        border-radius: 7px;
        font-size: 20px;

        .header {
            font-size: 18px;
            display: flex;
            width: 100%;
            justify-content: start;
            text-transform: uppercase;
            font-weight: 600;
            font-family: var(--font-family);
        }

        .name {
            font-size: 24px;
        }
    }

    .studbook-original {
        background: var(--primary-color-semitransparent);
    }
}
</style>
